/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.index-of.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import Hammer from 'hammerjs';
moment.locale('zh-cn');
var today = moment();
export default {
  props: {
    minDate: {
      type: String,
      "default": ''
    },
    maxDate: {
      type: String,
      "default": ''
    },
    dateWithDot: {
      type: Array,
      "default": []
    }
  },
  data: function data() {
    var firstDate = moment(); //.date(1).day(0).format('YYYY-MM-DD')
    // let firstDate = moment([2017, 9, 31])

    return {
      today: today,
      firstDate: firstDate,
      selectedIndex: -1
    };
  },
  computed: {
    dates: function dates() {
      var first = moment(this.firstDate, 'YYYY-MM-DD').date(1).day(0);
      var lastDate = moment(this.firstDate, 'YYYY-MM-DD').endOf('month').day(6);
      return Array.from({
        length: lastDate.diff(first, 'day') + 1
      }, function (v, i) {
        return i;
      }).map(function (x) {
        return moment(first).add(x, 'd');
      });
    },
    firstDateMoment: function firstDateMoment() {
      return moment(this.firstDate, 'YYYY-MM-DD');
    }
  },
  methods: {
    getDate: function getDate(index) {
      if (this.isDisable(this.dates[index]) || !this.dateWithDotFlag(this.dates[index])) {
        return;
      }

      this.selectedIndex = index;
      this.$emit('dateSelected', this.dates[index]);
    },
    isDisable: function isDisable(date) {
      if (this.minDate && this.maxDate) {
        return date.isBefore(this.minDate, 'day') || date.isAfter(this.maxDate, 'day');
      } else if (this.minDate) {
        return date.isBefore(this.minDate, 'day');
      } else if (this.maxDate) {
        return date.isAfter(this.maxDate, 'day');
      } else {
        return true;
      }
    },
    dateWithDotFlag: function dateWithDotFlag(d) {
      var dateWithDot = this.dateWithDot;
      return dateWithDot.indexOf(d.format('YYYY-MM-DD')) >= 0;
    },
    lastWeek: function lastWeek() {
      if (this.minDate) {
        if (this.firstDateMoment.isBefore(this.minDate, 'day') || this.firstDateMoment.isSame(this.minDate, 'day')) {
          return;
        }
      }

      this.selectedIndex = -1;
      var m = moment(this.firstDate, 'YYYY-MM-DD');
      this.firstDate = m.add(-1, 'months').format('YYYY-MM-DD');
      var lastDate = moment(m).endOf('month').day(6);
      this.$emit('lastWeek', this.firstDate, lastDate.format('YYYY-MM-DD'));
    },
    nextWeek: function nextWeek() {
      var next = moment(this.firstDate, 'YYYY-MM-DD').add(1, 'months');
      var first = moment(next).date(1).day(0);
      var lastDate = moment(next).endOf('month').day(6);

      if (this.maxDate) {
        if (first.isAfter(this.maxDate, 'day') || first.isSame(this.maxDate, 'day')) {
          return;
        }
      }

      this.firstDate = moment(next).format('YYYY-MM-DD');
      this.selectedIndex = -1;
      this.$emit('nextWeek', first.format('YYYY-MM-DD'), lastDate.format('YYYY-MM-DD'));
    }
  },
  mounted: function mounted() {
    // 默认选中当天
    // this.selectedIndex = this.dates.findIndex(x => x.isSame(today, 'day'))
    // 滑动切换日期
    var that = this;
    this.mc = new Hammer(this.$el);
    this.mc.on("swipeleft", function (ev) {
      that.nextWeek();
    });
    this.mc.on("swiperight", function (ev) {
      that.lastWeek();
    });
  }
};